import { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { BellOutlined, BellFilled } from '@ant-design/icons';
import { usePushWrapper } from '_helpers';

export { PushToggle };

/** Detect iOS Safari that is NOT yet installed to the home screen. */
function isIosNotInstalled() {
    const ua = window.navigator.userAgent || '';
    const isIos = /iphone|ipad|ipod/i.test(ua);
    const standalone =
        window.navigator.standalone === true ||
        (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches);
    return isIos && !standalone;
}

function PushToggle() {
    const push = usePushWrapper();
    const [status, setStatus] = useState('loading'); // loading|unsupported|denied|default|subscribed
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        let alive = true;
        push.getStatus().then((s) => { if (alive) setStatus(s); });
        return () => { alive = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function onEnable() {
        setBusy(true);
        const r = await push.enablePush();
        setBusy(false);
        if (r.ok) {
            setStatus('subscribed');
            message.success('Đã bật thông báo trên thiết bị này');
        } else {
            message.error(r.error || 'Không thể bật thông báo');
            setStatus(await push.getStatus());
        }
    }

    async function onDisable() {
        setBusy(true);
        await push.disablePush();
        setBusy(false);
        setStatus('default');
        message.success('Đã tắt thông báo trên thiết bị này');
    }

    if (status === 'loading') return null;

    if (status === 'unsupported') {
        if (isIosNotInstalled()) {
            return (
                <div className="profile-push-row">
                    <BellOutlined className="profile-push-icon" />
                    <span className="profile-push-hint">
                        Để nhận thông báo trên iPhone/iPad: nhấn <b>Chia sẻ</b> → <b>Thêm vào MH chính</b>,
                        rồi mở ứng dụng từ màn hình chính và bật lại.
                    </span>
                </div>
            );
        }
        return null; // browser genuinely can't do push — hide quietly
    }

    if (status === 'denied') {
        return (
            <div className="profile-push-row">
                <BellOutlined className="profile-push-icon profile-push-icon-bad" />
                <span className="profile-push-hint">
                    Thông báo đang bị chặn. Hãy bật lại quyền thông báo cho trang này trong cài đặt trình duyệt.
                </span>
            </div>
        );
    }

    const subscribed = status === 'subscribed';
    return (
        <div className="profile-push-row">
            <Button
                type={subscribed ? 'default' : 'primary'}
                icon={subscribed ? <BellFilled /> : <BellOutlined />}
                loading={busy}
                onClick={subscribed ? onDisable : onEnable}
            >
                {subscribed ? 'Tắt thông báo' : 'Bật thông báo'}
            </Button>
            <span className="profile-push-hint">
                {subscribed
                    ? 'Bạn sẽ nhận thông báo điểm mới, điểm danh và bài tập trên thiết bị này.'
                    : 'Nhận thông báo điểm mới, điểm danh vắng/muộn và bài tập mới.'}
            </span>
        </div>
    );
}
